import { lazy } from "react";
import { PATHS } from "@/lib/router";
import { FeatureProvider, Feature_NAMESPACES } from "@/lib/i18n";

const BillOcrPage = lazy(() =>
  import("./pages/BillOcrPage").then((m) => ({ default: m.BillOcrPage })),
);

export const billOcrRoutes = [
  {
    path: PATHS.BILL_OCR,
    element: (
      <FeatureProvider namespace={Feature_NAMESPACES.BILL_OCR}>
        <BillOcrPage />
      </FeatureProvider>
    ),
    handle: { permission: { resource: "esg_data_entry", action: "view" } },
  },
];
